import { render, staticRenderFns } from "./review_edit.vue?vue&type=template&id=4585d890&scoped=true&"
import script from "./review_edit.vue?vue&type=script&lang=js&"
export * from "./review_edit.vue?vue&type=script&lang=js&"
import style0 from "./review_edit.vue?vue&type=style&index=0&id=4585d890&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4585d890",
  null
  
)

export default component.exports